// extracted by mini-css-extract-plugin
export default {"col":"ModalSelect_col__AyAaL","table":"ModalSelect_table__sIU+r"};